module.exports = __webpack_public_path__ + "static/media/point_effect.10f66ce9.mp3";